import React, { useEffect, useState } from 'react';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Services
import ReportService from '../../services/report-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const ReportList = () => {
  const [error, setError] = useState(false);
  const [reportList, setReportList] = useState<ListContent[]>(null);

  const titles: ListContentTitle[] = [
    { text: 'Nome' },
    { text: 'Descrição' },
  ];

  useEffect(() => {
    const storageService = new StorageService();
    const schoolService = new SchoolService();
    const schoolId = storageService.getEmployee().schoolId;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        const reportService = new ReportService(school.uuid);
        return reportService.listReports();
      })
      .then((reports) => {
        const list: ListContent[] = reports.map((report) => ({
          linkTo: `/relatorios/${report.id}`,
          data: [
            { text: report.name },
            { text: report.description },
          ],
        }));
        setReportList(list);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!reportList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <FeatureTitle title='relatórios' />

      {reportList.length > 0 ? (
        <List titles={titles} contents={reportList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default ReportList;
